"use client";
import dashboardImg from "../../assets/LandingPage/Dashboard.png";
import { useNavigate } from "react-router-dom";

export default function Differentiators() {
  const navigate = useNavigate();
  return (
    <section className="relative bg-white py-16 sm:py-20 lg:py-28 px-6 sm:px-10 lg:px-20">
      <div className="relative z-10 flex flex-col lg:flex-row items-center lg:items-start justify-between gap-12 lg:gap-20 max-w-7xl mx-auto">
        <div className="flex flex-col justify-start items-center lg:items-start text-center lg:text-left w-full lg:w-[55%]">
          <div className="relative flex flex-row justify-center lg:justify-start gap-2 items-center bg-[#EAF3FF] text-[#0A66FF] font-medium px-4 py-1 rounded-full mb-12 text-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M11 19V15.9C10.1833 15.7167 9.45417 15.3708 8.8125 14.8625C8.17083 14.3542 7.7 13.7167 7.4 12.95C6.15 12.8 5.10417 12.2542 4.2625 11.3125C3.42083 10.3708 3 9.26667 3 8V7C3 6.45 3.19583 5.97917 3.5875 5.5875C3.97917 5.19583 4.45 5 5 5H7C7 4.45 7.19583 3.97917 7.5875 3.5875C7.97917 3.19583 8.45 3 9 3H15C15.55 3 16.0208 3.19583 16.4125 3.5875C16.8042 3.97917 17 4.45 17 5H19C19.55 5 20.0208 5.19583 20.4125 5.5875C20.8042 5.97917 21 6.45 21 7V8C21 9.26667 20.5792 10.3708 19.7375 11.3125C18.8958 12.2542 17.85 12.8 16.6 12.95C16.3 13.7167 15.8292 14.3542 15.1875 14.8625C14.5458 15.3708 13.8167 15.7167 13 15.9V19H16C16.2833 19 16.5208 19.0958 16.7125 19.2875C16.9042 19.4792 17 19.7167 17 20C17 20.2833 16.9042 20.5208 16.7125 20.7125C16.5208 20.9042 16.2833 21 16 21H8C7.71667 21 7.47917 20.9042 7.2875 20.7125C7.09583 20.5208 7 20.2833 7 20C7 19.7167 7.09583 19.4792 7.2875 19.2875C7.47917 19.0958 7.71667 19 8 19H11ZM7 10.8V7H5V8C5 8.63333 5.18333 9.20417 5.55 9.7125C5.91667 10.2208 6.4 10.5833 7 10.8ZM12 14C12.8333 14 13.5417 13.7083 14.125 13.125C14.7083 12.5417 15 11.8333 15 11V5H9V11C9 11.8333 9.29167 12.5417 9.875 13.125C10.4583 13.7083 11.1667 14 12 14ZM17 10.8C17.6 10.5833 18.0833 10.2208 18.45 9.7125C18.8167 9.20417 19 8.63333 19 8V7H17V10.8Z"
                fill="#0088FF"
              />
            </svg>
            <span>Platform Differentiators</span>
          </div>

          <div className="hidden sm:block sm:absolute top-0 right-0 z-0 opacity-50 pointer-events-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="997"
              height="54"
              viewBox="0 0 997 54"
              fill="none"
            >
              <path
                d="M-0.000400875 53.4141L532.705 53.4143L532.705 0.500022L1112.71 0.499967"
                stroke="url(#paint0_linear_752_9760)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_752_9760"
                  x1="-0.539606"
                  y1="1.11523"
                  x2="1952.44"
                  y2="178.36"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#0088FF" />
                  <stop offset="1" stop-color="#EAF524" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <h2 className="relative text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-snug sm:leading-normal lg:leading-[1.3] mb-6">
            Why SourceIQ Leads the{" "}
            <div
              className="hidden sm:block sm:absolute  -right-full top-6 mt-2 w-[200px] opacity-60 pointer-events-none"
              style={{ zIndex: 50 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="562"
                height="1"
                viewBox="0 0 562 1"
                fill="none"
              >
                <path
                  d="M1.33546e-05 0.499615L678 0.499783"
                  stroke="url(#paint0_linear_752_9759)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_752_9759"
                    x1="-0.328604"
                    y1="0.874818"
                    x2="1189.67"
                    y2="108.875"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#0088FF" />
                    <stop offset="1" stop-color="#EAF524" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <span className="relative bg-gradient-to-r from-[#0088FF] to-[#516C9F] bg-clip-text text-transparent">
              Market
              <div
                className="hidden sm:block sm:absolute  left-40  top-6 mt-2 w-[200px] opacity-60 pointer-events-none"
                style={{ zIndex: 50 }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1190"
                  height="107"
                  viewBox="0 0 1190 107"
                  fill="none"
                >
                  <path
                    d="M0.000362285 0.500483L541.171 0.500162L541.171 106.376L1189.17 106.376"
                    stroke="url(#paint0_linear_752_9758)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_752_9758"
                      x1="-0.32864"
                      y1="0.875994"
                      x2="1189.67"
                      y2="108.876"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#0088FF" />
                      <stop offset="1" stop-color="#EAF524" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </span>
          </h2>

          <p className="text-gray-600 text-base sm:text-lg mb-10">
            Built from the ground up with modern cloud architecture and AI at
            its core, SourceIQ delivers capabilities that traditional
            procurement tools simply can’t match.
          </p>

          <ul className="space-y-4 mb-10 text-left">
            {[
              "Autonomous supplier matching powered by proprietary AI models",
              "Marketplace pre-populated with 100K+ scrubbed supplier records",
              "Cloud-native for fast deployment and scale",
              "Modular, role-based access for cross-department collaboration",
              "Built-in analytics and compliance-ready audit logs",
            ].map((item, idx) => (
              <li
                key={idx}
                className="flex items-center sm:items-center gap-3 text-sm sm:text-base"
              >
                <div className="flex-shrink-0 w-7 h-7 sm:w-7 sm:h-7">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 40 40"
                    fill="none"
                    className="w-full h-full"
                  >
                    <rect
                      width="28"
                      height="28"
                      x="6"
                      y="6"
                      rx="5.6"
                      fill="url(#paint0_linear_752_9765)"
                    />
                    <g transform="scale(0.7) translate(8.571,8.571)">
                      <path
                        d="M19.9997 36.6663C17.6941 36.6663 15.5275 36.2288 13.4997 35.3538C11.4719 34.4788 9.70801 33.2913 8.20801 31.7913C6.70801 30.2913 5.52051 28.5275 4.64551 26.4997C3.77051 24.4719 3.33301 22.3052 3.33301 19.9997C3.33301 17.6941 3.77051 15.5275 4.64551 13.4997C5.52051 11.4719 6.70801 9.70801 8.20801 8.20801C9.70801 6.70801 11.4719 5.52051 13.4997 4.64551C15.5275 3.77051 17.6941 3.33301 19.9997 3.33301C21.333 3.33301 22.6316 3.48579 23.8955 3.79134C25.1594 4.0969 26.3747 4.54134 27.5413 5.12467C27.958 5.3469 28.2288 5.68023 28.3538 6.12467C28.4788 6.56912 28.4025 6.98579 28.1247 7.37467C27.8469 7.76356 27.4788 8.01356 27.0205 8.12467C26.5622 8.23579 26.1108 8.18023 25.6663 7.95801C24.7775 7.54134 23.8538 7.2219 22.8955 6.99967C21.9372 6.77745 20.9719 6.66634 19.9997 6.66634C16.3052 6.66634 13.1594 7.96495 10.5622 10.5622C7.96495 13.1594 6.66634 16.3052 6.66634 19.9997C6.66634 23.6941 7.96495 26.84 10.5622 29.4372C13.1594 32.0344 16.3052 33.333 19.9997 33.333C23.6941 33.333 26.84 32.0344 29.4372 29.4372C32.0344 26.84 33.333 23.6941 33.333 19.9997C33.333 19.7775 33.3261 19.5622 33.3122 19.3538C33.2983 19.1455 33.2775 18.9302 33.2497 18.708C33.1941 18.2358 33.2844 17.7844 33.5205 17.3538C33.7566 16.9233 34.1108 16.6386 34.583 16.4997C35.0275 16.3608 35.4441 16.4025 35.833 16.6247C36.2219 16.8469 36.4441 17.1802 36.4997 17.6247C36.5552 18.0136 36.5969 18.4025 36.6247 18.7913C36.6525 19.1802 36.6663 19.583 36.6663 19.9997C36.6663 22.3052 36.2288 24.4719 35.3538 26.4997C34.4788 28.5275 33.2913 30.2913 31.7913 31.7913C30.2913 33.2913 28.5275 34.4788 26.4997 35.3538C24.4719 36.2288 22.3052 36.6663 19.9997 36.6663ZM17.6663 22.9997L33.1663 7.45801C33.4719 7.15245 33.8538 6.99273 34.3122 6.97884C34.7705 6.96495 35.1663 7.12467 35.4997 7.45801C35.8052 7.76356 35.958 8.15245 35.958 8.62467C35.958 9.0969 35.8052 9.48579 35.4997 9.79134L18.833 26.4997C18.4997 26.833 18.1108 26.9997 17.6663 26.9997C17.2219 26.9997 16.833 26.833 16.4997 26.4997L11.7497 21.7497C11.4441 21.4441 11.2913 21.0552 11.2913 20.583C11.2913 20.1108 11.4441 19.7219 11.7497 19.4163C12.0552 19.1108 12.4441 18.958 12.9163 18.958C13.3886 18.958 13.7775 19.1108 14.083 19.4163L17.6663 22.9997Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_752_9765"
                        x1="20"
                        y1="0"
                        x2="20"
                        y2="40"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#0088FF" />
                        <stop offset="1" stop-color="#EAF524" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <span className="text-gray-700">{item}</span>
              </li>
            ))}
          </ul>
          <button
            onClick={() => navigate("/signup")}
            className="flex flex-row justify-center lg:justify-start items-center gap-2 bg-[#0088FF] text-white px-12 py-4 rounded-xl font-medium text-sm sm:text-base transition-all"
          >
            Explore Platform
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M16.5192 11.1362C17.1807 11.5221 17.1807 12.4779 16.5192 12.8638L7.50387 18.1227C6.83721 18.5116 6 18.0308 6 17.259L6 6.74104C6 5.96925 6.83721 5.48838 7.50387 5.87726L16.5192 11.1362Z"
                fill="white"
              />
            </svg>
          </button>
        </div>

        <div className="w-full md:w-[60%] flex justify-center lg:justify-center mt-10 lg:mt-40">
          <img
            src={dashboardImg}
            width={583}
            height={378}
            alt="Dashboard placeholder"
            className="w-full max-w-[500px] object-contain mx-auto"
            style={{ zIndex: 10000 }}
          />
        </div>
      </div>
    </section>
  );
}
